import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArrowRightAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"arrow_right_alt"}/>
}
